export default "__VITE_ASSET__B79FVa05__"